import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { PlayerMode } from '../../../services/course-player.service';

@Component({
  selector: 'app-course-player-header',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './course-player-header.component.html',
  styleUrls: ['./course-player-header.component.scss']
})
export class CoursePlayerHeaderComponent {
  // Navigation inputs
  @Input() title: string = '';
  @Input() customHeaderContent?: string;
  @Input() currentIndex: number = 0;
  @Input() totalItems: number = 1;
  @Input() canGoToPrevious: boolean = false;
  @Input() canGoToNext: boolean = false;
  @Input() showNavigation: boolean = true;

  // Action button inputs
  @Input() showTimelineToggle: boolean = false;
  @Input() timelineVisible: boolean = false;
  @Input() showFullscreen: boolean = false;
  @Input() isFullscreen: boolean = false;
  @Input() showCloseButton: boolean = true;

  // Player mode (for instructor badge)
  @Input() mode: PlayerMode = 'learner';

  // Event outputs
  @Output() onNavigatePrevious = new EventEmitter<void>();
  @Output() onNavigateNext = new EventEmitter<void>();
  @Output() onTimelineToggle = new EventEmitter<void>();
  @Output() onFullscreenToggle = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  /**
   * Get mode display info for badge
   */
  getModeDisplayInfo(): { name: string; color: string } {
    switch (this.mode) {
      case 'instructor_preview':
        return { name: 'Preview Mode', color: 'badge-info' };
      case 'instructor_test':
        return { name: 'Test Mode', color: 'badge-warning' };
      default:
        return { name: 'Learner', color: 'badge-primary' };
    }
  }
}
